var render, staticRenderFns
import script from "./AddressFunctionality.vue?vue&type=script&lang=js&"
export * from "./AddressFunctionality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19adb0de",
  null
  
)

export default component.exports